// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/powerups/card-aging/TopLeftLevel1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("resources/images/powerups/card-aging/TopRightLevel1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("resources/images/powerups/card-aging/BottomLeftLevel1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("resources/images/powerups/card-aging/BottomRightLevel1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("resources/images/powerups/card-aging/TopLeftLevel2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("resources/images/powerups/card-aging/TopRightLevel2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("resources/images/powerups/card-aging/BottomLeftLevel2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("resources/images/powerups/card-aging/BottomRightLevel2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("resources/images/powerups/card-aging/TopLeftLevel3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("resources/images/powerups/card-aging/TopRightLevel3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("resources/images/powerups/card-aging/BottomLeftLevel3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("resources/images/powerups/card-aging/BottomRightLevel3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("resources/images/powerups/card-aging/BottomRightLevel3Treasure.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N_c1Mf6NhXNbSZ {
  opacity: 0.8;
}
.tfoZHhs0OhuTdP {
  opacity: 0.6;
}
.gicBHArXnzAkFj {
  opacity: 0.4;
}
div.YnrMg6bRs72An1 {
  background-color: hsl(39, 55%, 96%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___}), url(${___CSS_LOADER_URL_REPLACEMENT_2___}), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: top left,
    top right,
    bottom left,
    bottom right;
  box-shadow: inset 0 0 15px hsla(33, 42%, 66%, 0.4);
}
div.YnrMg6bRs72An1 [data-card-front-section='cover'],
div.YnrMg6bRs72An1 [data-smart-element='Preview'] {
  opacity: 0.8;
}
div.sIksQCSKfxFdhP {
  background-color: hsl(39, 55%, 91%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}), url(${___CSS_LOADER_URL_REPLACEMENT_5___}), url(${___CSS_LOADER_URL_REPLACEMENT_6___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: top left,
    top right,
    bottom left,
    bottom right;
  box-shadow: inset 0 0 25px hsla(33, 42%, 66%, 0.5);
}
div.sIksQCSKfxFdhP [data-card-front-section='cover'],
div.sIksQCSKfxFdhP [data-smart-element='Preview'] {
  opacity: 0.6;
}
div.dRah_9BW_sJVWm,
div.xT5XUnLVknnzKa {
  background-color: hsl(39, 55%, 86%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_9___}), url(${___CSS_LOADER_URL_REPLACEMENT_10___}), url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: top left,
    top right,
    bottom left,
    bottom right;
  box-shadow: inset 0 0 40px hsla(33, 42%, 66%, 0.6);
}
div.dRah_9BW_sJVWm [data-card-front-section='cover'],
div.xT5XUnLVknnzKa [data-card-front-section='cover'],
div.dRah_9BW_sJVWm [data-smart-element='Preview'],
div.xT5XUnLVknnzKa [data-smart-element='Preview'] {
  opacity: 0.4;
}
div.xT5XUnLVknnzKa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_9___}), url(${___CSS_LOADER_URL_REPLACEMENT_10___}), url(${___CSS_LOADER_URL_REPLACEMENT_11___}), url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-position: top left,
    top right,
    bottom left,
    bottom right,
    bottom 1px right 10px;
}
html[data-color-mode='dark']  div.YnrMg6bRs72An1,
html[data-color-mode='dark']  div.sIksQCSKfxFdhP,
html[data-color-mode='dark']  div.dRah_9BW_sJVWm,
html[data-color-mode='dark']  div.xT5XUnLVknnzKa {
  background-blend-mode: color-burn;
}
html[data-color-mode='dark']  div.YnrMg6bRs72An1 {
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: inset 0 0 40px rgba(29, 33, 37, 0.4);
}
html[data-color-mode='dark']  div.sIksQCSKfxFdhP {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  box-shadow: inset 0 0 40px rgba(29, 33, 37, 0.5);
}
html[data-color-mode='dark']  div.dRah_9BW_sJVWm,
html[data-color-mode='dark']  div.xT5XUnLVknnzKa {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  box-shadow: inset 0 0 40px rgba(29, 33, 37, 0.6);
}
`, ""]);
// Exports
var _1 = `N_c1Mf6NhXNbSZ`;
export { _1 as "aging-regular-level-1" };
var _2 = `tfoZHhs0OhuTdP`;
export { _2 as "aging-regular-level-2" };
var _3 = `gicBHArXnzAkFj`;
export { _3 as "aging-regular-level-3" };
var _4 = `YnrMg6bRs72An1`;
export { _4 as "aging-pirate-level-1" };
var _5 = `sIksQCSKfxFdhP`;
export { _5 as "aging-pirate-level-2" };
var _6 = `dRah_9BW_sJVWm`;
export { _6 as "aging-pirate-level-3" };
var _7 = `xT5XUnLVknnzKa`;
export { _7 as "aging-pirate-level-3-treasure" };
export default ___CSS_LOADER_EXPORT___;
